import { render, staticRenderFns } from "./customTableDialog.vue?vue&type=template&id=9796037a"
import script from "./customTableDialog.vue?vue&type=script&lang=js"
export * from "./customTableDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports